module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-bookitalic-webfont.2806046d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-bookitalic-webfont.woff
// module id = 374
// module chunks = 3